import React from 'react';
import { PropTypes } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import CardType from './CardType';
import Input from '../../components/Forms/Input';
import styles from './CardList.css';
import CreditCardInfoForm from '../../components/Forms/CreditCardInfoForm';

const CardList = ({ paymentOptions, selectedCard, profileId, token }) => (
  <div>
    <h3 className={styles.cardTypeTitle}>Payment</h3>
    <form>
      <ul className={styles.list}>
        {paymentOptions.map((card, index) => {
          return (
            <div key={index} className={styles.cardTypeContainer}>
              <Field
                className={styles.radio}
                type="radio"
                component={Input}
                name="selectedCreditCard"
                value={`${card.paymentProfileId}`}
                selected={
                  (card.paymentProfileId
                    ? card.paymentProfileId.toString()
                    : '') === selectedCard
                }
              />
              <CardType
                ccNum={card.creditCardNumber}
                paymentProfileId={`${card.paymentProfileId}`}
              />
            </div>
          );
        })}
      </ul>
    </form>
    <CreditCardInfoForm hidden profileId={profileId} token={token} />
  </div>
);

CardList.propTypes = {
  paymentOptions: PropTypes.array,
  selectedCard: PropTypes.string,
  profileId: PropTypes.string,
  token: PropTypes.string,
};

export const cardSelection = 'CreditCardList';

export default reduxForm({
  form: cardSelection,
})(CardList);



// WEBPACK FOOTER //
// ./src/containers/Modals/CardList.jsx